import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DataElement } from '../../components/data-element/data-element.component';
import { DateTimeDisplay } from '../../components/date-time-display/date-time-display.component';
import { ElementWrapper } from '../../components/element-wrapper/element-wrapper.component';
import { Map } from '../../components/map/map.component';
import { PageContentWrapper } from '../../components/page-content-wrapper/page-content-wrapper.component';
import { PageHeader } from '../../components/page-header/page-header.component';
import { useAuth } from '../../contexts/UserContext';
import { ApiService } from '../../services/api';
import { ApiError } from '../../services/api/core/ApiError';
import { GeoLocation } from '../../services/api/models/GeoLocation';

export const UnitLocation: FC = () => {
  const [location, setLocation] = useState<GeoLocation | null>();

  const { unitId, locationId } = useParams();

  const { logout } = useAuth();


  useEffect(() => {
    const fetchLocations = async () => {
      if (unitId && locationId) {
        try { 
          const locations = await ApiService.getLocationHistory(Number(unitId));
          if (locations && locations.length > 0) {
            setLocation(locations[Number(locationId)]);
          } else {
            setLocation(null);
          }
        } catch (e) { 
          if (e instanceof ApiError && (e.status === 400 || e.status === 401 || e.status === 403)) { 
            logout();
          }
        }

      }
    };

    fetchLocations();



  }, [locationId, unitId]);

  return (
    <div className="flex flex-1 flex-col">
      <PageHeader title="Asset Location" showBack />
      {
        location && <Map location={{ lat: location.latitude || 0, lng: location.longitude || 0 }} radius={location.confidenceRadius} height={400} type={location.locationType === 'GPS' ? 'GPS' : 'SLEEPER'} />
      }
      <div className={`${location && 'bg-white'} flex-1 flex`}>
        <div className={`${location && '-translate-y-10'} flex-1`}>
          <PageContentWrapper>
            {
              location === undefined
                ?
                <h1>Loading...</h1>
                :
                location === null
                  ?
                  <h1>Location not found</h1>
                  :
                  <>

                    {location && (
                      <div className="flex flex-col gap-2">
                        <ElementWrapper title="Reported Time">
                          <DateTimeDisplay isoDate={location.eventDate || undefined} enlarge />
                        </ElementWrapper>

                        <div className="flex gap-1 sm:gap-2 md:gap-4">
                          <DataElement title="Latitude" body={String(location.latitude)} />
                          <DataElement title="Longitude" body={String(location.longitude)} />
                        </div>

                        <DataElement title="Address" body={location.address || ''} />

                        <ElementWrapper title="Maps"><div className="fontMain font-bold whitespace-normal"><h4>
                        {location.locationType === 'GPS' ? (
                          <a href={'https://www.google.com/maps/search/?api=1&query=' + String(location.latitude) + '%2C' + String(location.longitude) + '&z=15'} target="_blank" rel="noopener noreferrer">Open In Google Maps</a>
                        ) : (
                          <a href={'https://www.google.com/maps/@?api=1&map_action=map&center=' + String(location.latitude) + '%2C' + String(location.longitude) + ''} target="_blank" rel="noopener noreferrer">Open In Google Maps</a>
                        )}
                        </h4></div>
                        </ElementWrapper>
                     
                      </div>
                    )}
                  </>
            }
          </PageContentWrapper>
        </div>
      </div>

    </div>
  );
};
